/**
 * Swap the tab icon to the orange variant on every host except production,
 * so a dev tab and a prod tab are told apart at a glance.
 *
 * Keyed on hostname, not import.meta.env: local Docker (http://localhost)
 * serves a production build, so the build mode can't tell the two apart.
 */
export const PROD_HOSTNAME = 'dashboard.csgcloud.co.uk';

const DEV_ICONS = {
  'link[rel="icon"][sizes="32x32"]': '/favicon-dev-32x32.png',
  'link[rel="icon"][sizes="16x16"]': '/favicon-dev-16x16.png',
  'link[rel="apple-touch-icon"]': '/apple-touch-icon-dev.png',
};

export function applyEnvFavicon(doc = document, hostname = window.location.hostname) {
  if (hostname === PROD_HOSTNAME) return false;
  for (const [selector, href] of Object.entries(DEV_ICONS)) {
    const link = doc.querySelector(selector);
    if (link) link.setAttribute('href', href);
  }
  return true;
}
